import SvgIcon from '@mui/material/SvgIcon';
import React, { memo } from 'react';

import { petrol } from '../../styles/mui/colors';

/**
 * @param {import('@mui/material/SvgIcon').SvgIconProps} props
 * @returns {React.JSX.Element}
 */
const IconFacebookComponent = ({ color = petrol.main, ...rest }) => {
  return (
    <SvgIcon sx={{ color }} {...rest}>
      <svg fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path d="M13.5489 22V12.8777H16.6097L17.0689 9.32156H13.5489V7.05147C13.5489 6.0222 13.8336 5.32076 15.3112 5.32076L17.1928 5.31999V2.13923C16.8674 2.09695 15.7505 2 14.4505 2C11.7359 2 9.87739 3.65697 9.87739 6.69927V9.32156H6.80737V12.8777H9.87739V22H13.5489Z" />
      </svg>
    </SvgIcon>
  );
};

IconFacebookComponent.displayName = 'IconFacebook';
const IconFacebook = memo(IconFacebookComponent);

export default IconFacebook;
